// Taşeron portalı — Panel: "Bekleyen analizler" (api-contract §20.3 `?status=awaiting-review`).
// Belgeler sayfasındaki `PendingAnalysesStrip`'in panodaki AKRANI — AYNI veri
// (`useDocumentAnalysisList('awaiting-review')`), farklı yoğunlukta sunum. `PendingAnalysesStrip`
// KENDİSİ silinmedi/değişmedi (Belgeler sayfasında kalıyor); bu iki yüzey bilinçli olarak
// AYRI bileşenlerdir (tek bir yerde birleştirmek Belgeler sayfasının kartını da bu panele
// özel yoğunluk kurallarına bağlardı).
//
// **`PendingAnalysesStrip`'in dosya başı bulgusuyla AYNI disiplin:** her bekleyen analiz
// KENDİ satırını alır, KENDİ `pendingItemCount`'una ve KENDİ `uuid`'ine bağlanır — toplu tek
// sayı + tek CTA hedefi YANLIŞTIR (bir satırın arkasındaki sayı o satırın linkinin arkasındaki
// sayıyla HER ZAMAN eşit olmalı). Liste ZATEN `queuedAt` azalan sırada gelir (§20.3) — istemci
// yeniden SIRALAMAZ, ÇAPRAZLAMAZ.
//
// Boş durumda kart HİÇ RENDER EDİLMEZ (`return null`) — panonun çoğu ziyaretinde bekleyen
// analiz YOKTUR, boş bir kutu taşımak gürültüdür (sağ sütunda `UpcomingPermitsCard` zaten
// kendi boş durumunu gösterir, bu kart onun aksine sessiz kalır).

import { Skeleton, currentCulture } from '@isgportal/shared';
import { ChevronRight, FileSearch } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatDateTime } from '../../lib/format';
import { useDocumentAnalysisList } from '../../lib/useDocumentAnalysis';
import { DashboardPanel, PanelHeader } from './PanelHeader';

export function AwaitingAnalysisCard() {
  const { t } = useTranslation();
  const { items, isPending } = useDocumentAnalysisList('awaiting-review');
  const culture = currentCulture();

  // `isPending` dalı AYNI başlığı kullanır — kart yüklenirken de sonrasında da aynı yükseklikte
  // durur, veri gelince zıplamaz.
  if (isPending) {
    return (
      <DashboardPanel>
        <PanelHeader icon={FileSearch} title={t('dashboard.awaitingAnalysis.title')} />
        <div className="flex flex-col gap-3 px-4 py-4" aria-busy="true">
          <output className="sr-only">{t('dashboard.loading')}</output>
          <Skeleton className="h-4" />
          <Skeleton className="h-4 w-2/3" />
        </div>
      </DashboardPanel>
    );
  }

  // Savunmacı süzgeç — `PendingAnalysesStrip.tsx` ile AYNI not: uç zaten yalnız
  // `pendingItemCount > 0` analizleri döner (§20.3), bu satır o sözleşmeyi istemci
  // tarafında da tekrarlar.
  const rows = items.filter((item) => item.pendingItemCount > 0);
  if (rows.length === 0) {
    return null;
  }

  // İkon `FileSearch`: bu kartın satırlarının gittiği `DocumentAnalysisInboxPage`'in kendi ikonu.
  return (
    <DashboardPanel>
      <PanelHeader icon={FileSearch} title={t('dashboard.awaitingAnalysis.title')} />
      <ul className="flex flex-col pb-2">
        {rows.map((item) => (
          <li key={item.uuid} className="border-b border-border last:border-b-0">
            <Link
              to={`/document-analysis/${item.uuid}`}
              className="flex min-h-14 items-center gap-3 px-4 py-2 hover:bg-surface-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"
            >
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-fg">
                  {t('documents.pending.title', { count: item.pendingItemCount })}
                </p>
                {item.subjectUserUuid !== null ? (
                  <p className="truncate text-xs text-muted">
                    {t('documents.pending.personnel', { count: item.pendingItemCount })}
                  </p>
                ) : null}
                <p className="truncate text-xs text-muted tnum">
                  {t('documents.pending.queuedAt', {
                    date: formatDateTime(item.queuedAt, culture),
                  })}
                </p>
              </div>
              <ChevronRight className="h-4 w-4 shrink-0 text-muted" aria-hidden="true" />
            </Link>
          </li>
        ))}
      </ul>
    </DashboardPanel>
  );
}
